import React from 'react';
import classNames from 'classnames';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import PropTypes from 'prop-types';

import { CARD_ELEMENT_TYPE } from '../../../../../../../../../services/cards/constants';
import CardDesignerLayer from './CardDesignerLayer';

const propTypes = {
  style: PropTypes.object,
  element: PropTypes.shape({
    id: PropTypes.string,
    cardElement: PropTypes.shape({
      type: PropTypes.oneOf(Object.values(CARD_ELEMENT_TYPE)),
    }),
  }),
  isDraggable: PropTypes.bool,
};

const CardDesignerLayerSortable = ({ element, isDraggable, ...props }) => {
  const {
    isDragging,
    setNodeRef,
    transform,
    transition,
    attributes,
    listeners,
  } = useSortable({
    id: element?.id ?? element?.cardElement?.id,
    disabled: !isDraggable,
    data: {
      element,
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    ...(isDragging
      ? {
          zIndex: 999,
        }
      : {}),
  };

  const classes = classNames({
    'card-designer-layer-sortable': true,
    'is-draggable': isDraggable,
  });

  return (
    <div
      style={style}
      className={classes}
      ref={setNodeRef}
      {...attributes}
      {...listeners}
    >
      <CardDesignerLayer
        element={element}
        isDraggable={isDraggable}
        isDragging={isDragging}
        {...props}
      />
    </div>
  );
};

CardDesignerLayerSortable.propTypes = propTypes;

export default CardDesignerLayerSortable;
